import { Box, Grid } from "@material-ui/core"
import NCText from "../../shared/NCText"
import NCButton from "../../shared/NCButton"
import NCSvgIcon from "../../shared/NCSvgIcon"
import { AddIcon } from "../../libs/icons"
import AppointmentCalendar from "./AppointmentCalendar"
import { useQueryClient } from "react-query"
import {
  useGetDriverAppointments,
  useGetDriverList,
  useGetCalendarEvents
} from "../../services/queries"
import { useState } from "react"
import AppointmentModal from "./AddAppointmentModal"
import { format } from "date-fns"
import NCAutocomplete from "../../shared/NCAutocomplete"
import NotificationAlert from "../notification/NotificationAlert"
import { useTranslation } from "react-i18next"
const Appointments = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient()
  const [showAppointModal, setShowAppointmentModal] = useState(false)
  const [selectedDriverId, setSelectedDriverId] = useState()
  const [search, setSearch] = useState(null)
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"))
  const [startView, setStartView] = useState("DAY")
  const { data, isLoading } = useGetDriverList(search)
  const allData = data?.data?.data?.results || []

  // Selected driver's timezone — stored in state so the note stays put while
  // the driver list refetches (otherwise it flickers on/off)
  const [driverTimezone, setDriverTimezone] = useState()

  const handleAppointClick = () => {
    setShowAppointmentModal(true)
  }

  // Don't require the driver to be in `allData` — that list is filtered by the
  // search box, so typing would otherwise hide the selected driver's calendar.
  const isDriverSelected = !!selectedDriverId

  const { data: calendarEvents } = useGetCalendarEvents(
    {
      driver_id: selectedDriverId,
      date: startDate,
      filter: startView
    },
    {
      enabled: isDriverSelected,
      keepPreviousData: true
    }
  )

  const { data: driverAppointments, refetch: refetchDriverAppointments } = useGetDriverAppointments(
    {
      driver_id: selectedDriverId,
      date: startDate,
      filter: startView
    },
    { enabled: isDriverSelected, keepPreviousData: true }
  )

  // Get availability events from backend - calendar-events is double-wrapped
  const driverEvent = calendarEvents?.data?.data?.data || []
  const tripEvent = driverAppointments?.data?.data?.results || []
  
  // Ensure all events have required properties
  const validDriverEvents = Array.isArray(driverEvent) ? driverEvent.filter(e => e && e.start_time && e.end_time) : []
  const validTripEvents = Array.isArray(tripEvent) ? tripEvent.filter(e => e && e.start && e.end) : []

  const getAvailabilityData = (currentDate, view) => {
    setStartDate(currentDate)
    setStartView(view.toUpperCase())
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"space-between"}>
            <Box mb={2}>
              <NCText variant={"h4"} style={{ marginLeft: "10px", marginRight: "10px" }}>
                {t("appointments.heading")}
              </NCText>
            </Box>
            <Box mb={2} display={"flex"} gridGap={1} alignItems={"center"}>
              <NCButton
                variant="contained"
                color="primary"
                endIcon={<NCSvgIcon component={AddIcon} inheritViewBox />}
                onClick={() => handleAppointClick()}
                style={{ width: "auto" }}
              >
                {t("appointments.add_availability")}
              </NCButton>
              <NotificationAlert />
            </Box>

          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: "#F3F4F6",
            padding: "10px",
            paddingTop: "20px",
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            borderRadius: "10px"
          }}
        >
          <Grid item md="8" style={{ marginTop: "5px" }} xs={6}>
            <NCText>
              {t("appointments.message")}
            </NCText>
            
          </Grid>

          <Grid item md="5" xs={6} style={{ marginLeft: "10px" }}>
            <NCAutocomplete
              placeholder= {t("appointments.select_driver")}
              value={selectedDriverId}
              options={
                allData.map(item => {
                  return {
                    id: item?.id,
                    name: item?.name
                  }
                }) || []
              }
              name={"driver"}
              clearable
              onChange={driver => {
                setSelectedDriverId(driver)
                if (!driver) setSearch(null)
                const d = allData.find(item => item?.id === driver)
                setDriverTimezone(d?.timezone)
              }}
              loading={isLoading}
              onSearch={v => setSearch(v)}
            />
            {driverTimezone && (
              <NCText style={{ color: "#9CA3AF", fontSize: "12px", fontStyle: "italic" }}>
                Times are shown in the driver's timezone ({driverTimezone})
              </NCText>
            )}
          </Grid>
          <AppointmentModal
            modalState={showAppointModal}
            refetchDriverAppointments={refetchDriverAppointments}
            allData={allData}
            isLoading={isLoading}
            setSearch={setSearch}
            handleClose={() => {
              queryClient.refetchQueries("getDriverList")
              queryClient.refetchQueries("getDriverAvailability")
              setShowAppointmentModal(false)
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <AppointmentCalendar
            activities={isDriverSelected ? [...validDriverEvents, ...validTripEvents] : []}
            getInterval={(currentDate, view) =>
              getAvailabilityData(currentDate, view)
            }
            timezone={driverTimezone}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default Appointments
